// export const BACKEND_API = "http://0.0.0.0:8083/tg_portfolio/api/v1";

export const BACKEND_API = "https://frogtracker.app/tg_portfolio/api/v1";

export const MAGIC_EDEN_API = "https://api-mainnet.magiceden.io/rpc";
